import module_441fbaace9ed4d828cfcb356b4fc4742 from '../includes/glsl-compat.vert'
var fn = function( obj ){
var __t,__p='';
__p+=''+
(obj.version)+
'\n\n'+
(module_441fbaace9ed4d828cfcb356b4fc4742())+
'\n\n\nIN vec2 aPosition;\nOUT vec2 vTexCoord;\n\nuniform mat4 uMVP;\n\nvoid main(void){\n  gl_Position = uMVP * vec4(aPosition, 0.0, 1.0);\n  vTexCoord = aPosition;\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
